import { Textarea } from '../../ui/textarea';

export const MentalHealthStep = ({ formData, update }) => (
  <div className="space-y-5" data-testid="intake-step-mental">
    <h2 className="text-2xl font-bold text-darkBrown mb-2">Mental Health History</h2>
    <div className="space-y-1">
      <label className="text-sm font-medium text-darkBrown">Reason for Visit *</label>
      <Textarea data-testid="intake-reason" rows={3} value={formData.reasonForVisit} onChange={(e) => update('reasonForVisit', e.target.value)} placeholder="What brings you to our clinic?" className="resize-none" required />
    </div>
    <div className="space-y-1">
      <label className="text-sm font-medium text-darkBrown">Current Symptoms</label>
      <Textarea rows={3} value={formData.currentSymptoms} onChange={(e) => update('currentSymptoms', e.target.value)} placeholder="Describe any symptoms you are currently experiencing..." className="resize-none" />
    </div>
    <div className="space-y-1">
      <label className="text-sm font-medium text-darkBrown">Previous Mental Health Treatments</label>
      <Textarea rows={3} value={formData.previousTreatments} onChange={(e) => update('previousTreatments', e.target.value)} placeholder="Therapy, medications, hospitalizations, etc." className="resize-none" />
    </div>
    <div className="space-y-1">
      <label className="text-sm font-medium text-darkBrown">Substance Use</label>
      <Textarea rows={2} value={formData.substanceUse} onChange={(e) => update('substanceUse', e.target.value)} placeholder="Current or past use of alcohol, tobacco, or other substances..." className="resize-none" />
    </div>
  </div>
);
